import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { Progress } from '@repo/ui';

import ProcessCountdown from '@features/reservation/components/process/ProcessCountdown';

import parkingCar from '@assets/images/parking-car-small.webp';

interface Props {
  currentStep: 1 | 2 | 3;
  testId: TestId;
  secondsToDeadline?: number;
  onExpire?: () => void;
}

export default function ProcessProgress({ currentStep, testId, secondsToDeadline, onExpire }: Props) {
  return (
    <Progress
      currentStep={currentStep}
      image={<img src={parkingCar} alt="" className="h-8 w-auto object-contain" />}
      label={tr('reservations:timer.label')}
      rightContent={
        secondsToDeadline && onExpire ? (
          <ProcessCountdown remainingSeconds={secondsToDeadline} onExpire={onExpire} testId={testId.append('time')} />
        ) : undefined
      }
      testId={testId}
    />
  );
}
